// utils/EducationInfo

import React from 'react';
import { Box, Typography, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper } from '@mui/material';

// Define the education points data
const educationPoints = [
  { level: 'Less than secondary school (high school)', withSpouse: 0, withoutSpouse: 0 },
  { level: 'Secondary diploma (high school graduation)', withSpouse: 28, withoutSpouse: 30 },
  { level: 'One-year degree, diploma or certificate from a university, college, trade or technical school, or other institute', withSpouse: 84, withoutSpouse: 90 },
  { level: 'Two-year program at a university, college, trade or technical school, or other institute', withSpouse: 91, withoutSpouse: 98 },
  { level: 'Bachelor’s degree OR a three or more year program at a university, college, trade or technical school, or other institute', withSpouse: 112, withoutSpouse: 120 },
  { level: 'Two or more certificates, diplomas, or degrees. One must be for a program of three or more years', withSpouse: 119, withoutSpouse: 128 },
  { level: 'Master’s degree, or professional degree needed to practice in a licensed profession (e.g., law, medicine, dentistry, etc.)', withSpouse: 126, withoutSpouse: 135 },
  { level: 'Doctoral level university degree (Ph.D.)', withSpouse: 140, withoutSpouse: 150 },
];

const EducationComponent = ({ formData, calculateEducationPoints }) => (
  <Box>
    <Typography variant="h6">Education</Typography>
    <Typography>
      Higher education levels earn more points. A Master's degree or Ph.D. can significantly boost your score.
    </Typography>
    {formData?.educationLevel && (
      <Typography>Points for education: {calculateEducationPoints(formData.educationLevel)}</Typography>
    )}
    <TableContainer component={Paper} sx={{ marginTop: 2 }}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Education Level</TableCell>
            <TableCell align="right">Points (with spouse or common-law partner)</TableCell>
            <TableCell align="right">Points (without spouse or common-law partner)</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {educationPoints.map((row) => (
            <TableRow key={row.level}>
              <TableCell component="th" scope="row">
                {row.level}
              </TableCell>
              <TableCell align="right">{row.withSpouse}</TableCell>
              <TableCell align="right">{row.withoutSpouse}</TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    {/* Suggest related resources or information about credential equivalency if needed */}
  </Box>
);

export default EducationComponent;
